<div *ngIf="show" class="fixed inset-0 z-50 bg-black/60 flex items-center justify-center px-4">
  <div [ngClass]="{
         'bg-white text-black border border-gray-200': !dark,
         'bg-[#1e1e2f] text-white border border-gray-700': dark
       }"
       class="rounded-2xl max-w-md w-full p-4 relative shadow-2xl">

    <!-- Header -->
    <div class="flex justify-between items-center mb-3">
      <!-- 🔵/🟣 Titre piloté par mode -->
      <h1 class="text-base font-extrabold text-blue-600" [ngClass]="headerClass">
        {{ 'TOKEN_SELECT_TITLE' | translate }}
      </h1>


      <button (click)="close.emit()" class="text-gray-400 hover:text-red-500 text-lg">×</button>
    </div>

    <!-- Search Input -->
    <input [(ngModel)]="searchQuery" placeholder="{{ 'SEARCH_PLACEHOLDER' | translate }}"
           [ngClass]="{
             'bg-white text-black border-gray-300 placeholder-gray-500': !dark,
             'bg-gray-800 text-white border-gray-600 placeholder-gray-400': dark
           }"
           class="w-full mb-4 px-4 py-2 rounded-lg border text-sm" />

    <ul [ngClass]="dark ? 'divide-gray-700' : 'divide-gray-100'" class="divide-y max-h-96 overflow-y-auto">
      <!-- Vos tokens (si wallet connecté) -->
      <ng-container *ngIf="walletConnected">
        <li class="text-xs font-semibold px-2 pt-1 pb-1"
            [ngClass]="dark ? 'text-gray-400' : 'text-gray-500'">
          {{ 'YOUR_TOKENS' | translate }}
        </li>

        <ng-container *ngFor="let token of filtered(userTokens)">
          <li (click)="selectToken(token.symbol)"
              [ngClass]="
                dark
                  ? (mode === 'bridge' ? 'hover:bg-blue-900/30 text-white' : 'hover:bg-purple-900/30 text-white')
                  : (mode === 'bridge' ? 'hover:bg-blue-100/60 text-black' : 'hover:bg-purple-100/60 text-black')
              "
              class="flex justify-between items-center px-2 py-3 rounded-md transition cursor-pointer">
            <div class="flex items-center gap-2">
              <img [src]="token.logoURI" class="w-5 h-5 rounded-full" />
              <span class="text-sm font-medium">{{ token.symbol }}</span>
            </div>
            <div [ngClass]="dark ? 'text-gray-400' : 'text-gray-600'" class="text-sm text-right">
              {{ getTokenFiatValue(token) }} {{ selectedCurrency }}<br />
              <span class="text-xs"> {{ formatTokenAmount(+tokenBalances[token.address.toLowerCase() + '_' + token.chainId]) }}</span>
            </div>
          </li>
        </ng-container>
      </ng-container>

      <!-- Tokens par volume -->
      <li class="text-xs font-semibold px-2 pt-4 pb-1"
          [ngClass]="dark ? 'text-gray-400' : 'text-gray-500'">
        <span class="inline-flex items-center gap-1">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 10l7-7m0 0l7 7m-7-7v18" />
          </svg>
          {{ 'TOKENS_BY_VOLUME' | translate }}
        </span>
      </li>

      <ng-container *ngFor="let token of filtered(popularTokens)">
        <li (click)="selectToken(token.symbol)"
            [ngClass]="
              dark
                ? (mode === 'bridge' ? 'hover:bg-blue-900/30 text-white' : 'hover:bg-purple-900/30 text-white')
                : (mode === 'bridge' ? 'hover:bg-blue-100/60 text-black' : 'hover:bg-purple-100/60 text-black')
            "
            class="flex justify-between items-center px-2 py-3 rounded-md transition cursor-pointer">
          <div class="flex items-center gap-2">
            <img [src]="token.logoURI" class="w-5 h-5 rounded-full" />
            <span class="text-sm font-medium">{{ token.symbol }}</span>
          </div>
          <div *ngIf="walletConnected"
               [ngClass]="dark ? 'text-gray-400' : 'text-gray-600'"
               class="text-sm text-right">
            {{ getTokenFiatValue(token) }} {{ selectedCurrency }}<br />
            <span class="text-xs"> {{ formatTokenAmount(+tokenBalances[token.address.toLowerCase() + '_' + token.chainId]) }}</span>
          </div>
        </li>
      </ng-container>
    </ul>

  </div>
</div>
